import withRouter from './withRouter';
export { withRouter };
export default withRouter;
